import React from 'react';

import BackOfficeEnterpriseCreateButton from 'components/buttons/BackOfficeEnterpriseCreateButton';
import BackOfficeEnterpriseCreateDrawer from 'components/drawers/BackOfficeEnterpriseCreateDrawer';
import BackOfficeEnterpriseEditDrawer from 'components/drawers/BackOfficeEnterpriseEditDrawer';
import BackOfficeFilterDrawer from 'components/drawers/BackOfficeFilterDrawer';
import BackOfficeSection from 'components/features/backOffice/BackOfficeSection';
import BackOfficeEnterpriseFilterForm from 'components/forms/BackOfficeEnterpriseFilterForm';
import BackOfficeEnterprisesRequest from 'components/requests/BackOfficeEnterprisesRequest';
import CountriesRequest from 'components/requests/CountriesRequest';
import BackOfficeEnterprisesTable from 'components/tables/BackOfficeEnterprisesTable';
import { FilterSetName } from 'store/modules/routerUtils/types';

import useApplyDefaultSearchParams from './useApplyDefaultSearchParams';

function BackOfficeEnterprises(): JSX.Element {
  const { isSearchParamsReady } = useApplyDefaultSearchParams();

  return (
    <BackOfficeSection
      actions={<BackOfficeEnterpriseCreateButton />}
      table={<BackOfficeEnterprisesTable />}
      filterSetName={FilterSetName.BACK_OFFICE_ENTERPRISES}
      searchInputPlaceholder="Search by Name"
    >
      <BackOfficeEnterprisesRequest isReady={isSearchParamsReady} />
      <CountriesRequest />
      <BackOfficeEnterpriseCreateDrawer />
      <BackOfficeEnterpriseEditDrawer />
      <BackOfficeFilterDrawer
        filterSetName={FilterSetName.BACK_OFFICE_ENTERPRISES}
      >
        <BackOfficeEnterpriseFilterForm />
      </BackOfficeFilterDrawer>
    </BackOfficeSection>
  );
}

export default BackOfficeEnterprises;
